import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectedApexMech } from '@ortho-next/nextray-core';
import { BoneTypeEnum } from '../../core';
import { BaseComponent } from '../../shared';


/**
* Component of first vertical sidebar to select osteotomy site.
*/
@Component({
	selector: 'osteotomy-workflow',
	templateUrl: './osteotomy-workflow.component.html',
	imports: [
		FormsModule
	],
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class OsteotomyWorkflowComponent extends BaseComponent implements OnInit {

	site: ApexSiteEnum | null = null;
	readonly apexSiteEnum = ApexSiteEnum;


	ngOnInit(): void {
		this.site = this.apexSite();
	}

	get isLongLegVisible(): boolean {
		return this.hasLT ? this.boneTypeLT === BoneTypeEnum.LongLeg : this.isLongLeg;
	}
	get isFemurVisible(): boolean {
		return this.hasLT ? this.boneTypeLT === BoneTypeEnum.Femur : this.isFemur;
	}
	get isTibiaVisible(): boolean {
		return this.hasLT ? this.boneTypeLT === BoneTypeEnum.Tibia : this.isTibia;
	}


	/**
	* Close osteotomy site selection workflow.
	*/
	back(): void {
		this.canvasSrv.dispatch('cancelSelectingApex');
	}

	/**
	* Confirm insertion approach.
	*/
	confirm(): void {
		const event = this.selectedApexEvent();
		if (event) {
			this.canvasSrv.dispatch(event);
			this.canvasSrv.dispatch('confirmApex');
		}
	}

	private apexSite(): ApexSiteEnum | null {
		switch (this.selectedApex) {
			case SelectedApexMech.femurProximal: return ApexSiteEnum.ProximalFemur;
			case SelectedApexMech.femurDistal: return ApexSiteEnum.DistalFemur;
			case SelectedApexMech.tibiaProximal: return ApexSiteEnum.ProximalTibia;
			default: return null;
		}
	}

	private selectedApexEvent(): 'apexFemurProximal' | 'apexFemurDistal' | 'apexTibiaProximal' | null {
		switch (this.site) {
			case ApexSiteEnum.ProximalFemur: return 'apexFemurProximal';
			case ApexSiteEnum.DistalFemur: return 'apexFemurDistal';
			case ApexSiteEnum.ProximalTibia: return 'apexTibiaProximal';
			default: return null;
		}
	}

	/**
	 * Map label for apex site.
	 */
	apexSiteLabel(site: ApexSiteEnum | null): string {
		switch (site) {
			case ApexSiteEnum.ProximalFemur: return this.labels().INSERTION_APPROACH_ANTEGRADE_FEMUR;
			case ApexSiteEnum.DistalFemur: return this.labels().INSERTION_APPROACH_RETROGRADE_FEMUR;
			case ApexSiteEnum.ProximalTibia: return this.labels().INSERTION_APPROACH_ANTEGRADE_TIBIA;
			default: return '';
		}
	}

}


export enum ApexSiteEnum {
	ProximalFemur = 'Antegrade Femur',
	DistalFemur = 'Retrograde Femur',
	ProximalTibia = 'Antegrade Tibia'
}
